import { Text } from '@genial/components';
import { BoxRadius, Spacing, Color, Typography } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import React from 'react';
import { DimensionValue, StyleSheet, View } from 'react-native';

const styles = StyleSheet.create({
  container: {
    backgroundColor: Color['brand.tertiary.principal'],
    paddingVertical: Utils.Token.ToInt(Spacing, 'inset.nano'),
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: Utils.Token.ToInt(BoxRadius, 'xs'),
  },
  text: { textAlign: 'center' },
});

export namespace CategoryDividerProps {
  export type Props = {
    children: React.ReactNode;
  };
}

export const CategoryDivider: React.FC<CategoryDividerProps.Props> = ({ children }) => {
  const paddingHorizontal: DimensionValue = useBreakpointValue({
    base: Utils.Token.ToInt(Spacing, 'inset.nano'),
    md: Utils.Token.ToInt(Spacing, 'inset.sm'),
  });

  return (
    <View style={[styles.container, { paddingHorizontal }]}>
      <Text
        color="neutral.white"
        fontSize={{
          base: Typography['fontsize.md'],
          md: Typography['fontsize.lg'],
          lg: Typography['fontsize.xl'],
        }}>
        {children}
      </Text>
    </View>
  );
};
